<template>
  <div class="header">
    <div class="head_goback">
      <!-- 返回键   功能：返回上一页 -->
      <img src="../image/goback.png" v-if="goBack" alt @click="fanhui()">
      <!-- 关闭面板键 功能：关闭choosePet面板 -->
      <img src="../image/goback.png" v-if="noShow" alt @click="hideShow">
      <!-- <img src="../image/goback.png" v-if="goEdit" alt="" @click="goEdit"> -->
      <!-- 关闭面板键 功能：关闭修改宠物面板 -->
      <img src="../image/goback.png" v-if="isshow" alt @click="back">
      <!-- 关闭面板键 功能：关闭修改主人信息 -->
      <img src="../image/goback.png" v-if="isback" alt @click="backmsg">
      <!-- 关闭面板键 功能：关闭我的协寻详情 -->
      <img src="../image/goback.png" v-if="onshow" alt @click="backto">
      <!-- 关闭面板键 功能：关闭我的协寻 -->
      <img src="../image/goback.png" v-if="goBackac" alt @click="$router.push({path:'/myAccount'})">
      <!-- 返回登陆页面 -->
      <img src="../image/goback.png" v-if="goBackal" alt @click="$router.push({path:'/login'})">
      <!-- 返回mysearch页面 -->
      <img src="../image/goback.png" v-if="toMysearch" alt @click="$router.push({path:'/mysearch'})">
      <!-- 返回注册页 -->
      <img src="../image/goback.png" v-if="goBackag" alt @click="$router.push({path:'/register'})">
      <!-- 返回重置密码页 -->
      <img
        src="../image/goback.png"
        v-if="goBackaf"
        alt
        @click="$router.push({path:'/forgetpassword'})"
      >
    </div>
    <div class="imgBox">
      <!-- <img src="../image/logo-m.png" alt> -->
      <p v-if="register">{{$t('login.signUp')}}</p>
      <p v-if="forgetPsw">{{$t('forgetpassword.resetpassword')}}</p>
      <p v-if="mine">{{$t('login.platform')}}</p>
    </div>
    <!--<div class="rightBox">
      <img src="../image/edit.png" class="edit" v-if="isedit" @click="editpet">
      <img src="../image/edit.png" class="edit" v-if="isminenews" @click="minenews">
      <img src="../image/scan.png" class="edit" v-if="ifLogin" @click="addDevice" alt>
    </div>-->
    <div class="addList" v-if="isOpen">
      <div @click="toInputId">{{$t('login.enterid')}}</div>
      <div @click="toScan">{{$t('login.scanphone')}}</div>
    </div>
  </div>
</template>
<script>
import store from "../store/store.js";
import { systemInit, getLoginUser } from "../api/index.js";
export default {
  name: "Pheader",
  props: [
    "goBack",
    "addDevices",
    "noShow",
    "isshow",
    "isedit",
    "goBackac",
    "goBackal",
    "goBackag",
    "goBackaf",
    "ifLogin",
    "isminenews",
    "onshow",
    "isback",
    "register",
    "forgetPsw",
    "mine",
    "toMysearch"
  ],
  data() {
    return {
      authToken: sessionStorage.token,
      headToken: sessionStorage["login"],
      isOpen: false,
      lang:''
    };
  },
  created() {
    if (this.$route.query.lang) {
      if (this.$route.query.lang == "zh") {
        localStorage.setItem("locale", "zh");
      } else if (this.$route.query.lang == "en") {
        localStorage.setItem("locale", "en");
      } else if (this.$route.query.lang == "de") {
        localStorage.setItem("locale", "de");
      } else if (this.$route.query.lang == "ja") {
        localStorage.setItem("locale", "ja");
      }
    } else {
      var JsSrc = (
        navigator.language || navigator.browserLanguage
      ).toLowerCase();
      if (JsSrc.indexOf("zh") >= 0) {
        // 假如浏览器语言是中文
        localStorage.setItem("locale", "zh");
      } else if (JsSrc.indexOf("en") >= 0) {
        // 假如浏览器语言是英文
        localStorage.setItem("locale", "en");
      } else if (JsSrc.indexOf("de") >= 0) {
        // 假如浏览器语言是德语
        localStorage.setItem("locale", "de");
      } else if (JsSrc.indexOf("ja") >= 0) {
        // 假如浏览器语言是日语
        localStorage.setItem("locale", "ja");
      } else {
        //其他语言默认英语
        localStorage.setItem("locale", "en");
      }
    }
    //判断浏览器语言

    //将语言设备存入localstorage.
    this.$i18n.locale = localStorage.getItem("locale");
    this.lang = this.$i18n.locale;
//  console.log(this.lang)
    let storeLang = localStorage.getItem("locale")
    this.$store.commit("set_lang",storeLang)
  },
  mounted(){
//  console.log(this.lang)
    let storeLang = localStorage.getItem("locale")
    this.$store.commit("set_lang",storeLang)
  },
  methods: {
    langid(){
    	this.$emit("language",this.$i18n.locale)
    },
    hideShow() {
      //向父组（choosePet，这里嵌套的比较深）件传递关闭面板信息
      this.$emit("listen-head-show", false);
    },
    fanhui() {
				this.$router.push('/showInformation?accessToken='+localStorage.token+'&deviceCode='+localStorage.codeId)
    },
    goEdit() {
      this.$router.push("/mynewsedit");
    },
    back() {
      this.$emit("back");
    },
    // toMysearch(){
    //   this.$emit("toMysearch")
    // },
    backto() {
      this.$emit("backto");
    },
    editpet() {
      this.$emit("editpet");
    },
    backmsg() {
      this.$emit("backmsg");
    },
    minenews() {
      this.$emit("editmsg");
    },
    addDevice() {
      this.$emit('addDevice',true)
      // this.$router.push("/addDevice");
    },
    toScan() {},
    toInputId() {
      this.$router.push("/bindById");
    }
  }
};
</script>
<style scoped>
.header {
  width: 100%;
  position: relative;
  top: 0;
  text-align: center;
  background-color: #fff;
  height: 3rem;
  z-index: 10;
}
.head_goback {
  position: absolute;
  top: 0;
  left: 4%;
  z-index: 100;
  height: 3rem;
  line-height: 3rem;
}
.head_goback img {
  width: 0.7rem;
  vertical-align: middle;
}
.imgBox {
  height:3rem;
  line-height: 3rem;
}
.imgBox p{
  font-size: 1rem;
  border-bottom: 1px solid #e1e1e1;
}
/* .imgBox img {
  width: 8rem;
  vertical-align: middle;
} */

.rightBox {
  position: absolute;
  right: 3%;
  top: 0;
  height: 3rem;
  line-height: 3rem;
}
.rightBox img {
  width: 1.2rem;
  vertical-align: middle;
}
.addList {
  position: absolute;
  top: 40px;
  right: 3%;
  font-size: 0.8rem;
  background-color: rgba(0, 0, 0, 0.4);
  color: #fff;
  width: auto;
  padding: 5px 10px;
  border-radius: 5px;
  z-index: 99;
  transition: 0 0 0 0.5s;
}
.addList div:first-child {
  border-bottom: 1px solid #fff;
}
.addList div {
  padding: 5px;
}
.addList div::before {
  display: block;
  content: "";
  position: absolute;
  top: -10px;
  right: 5%;
  width: 0;
  height: 0;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-bottom: 10px solid rgba(0, 0, 0, 0.25);
  z-index: 10;
}
</style>




// WEBPACK FOOTER //
// src/components/header.vue